import type { AssessmentListItem } from '@assessments/shared'
import { AssessmentCard } from './AssessmentCard.js'
import { AssessmentEmptyState } from './AssessmentEmptyState.js'

/** Renders the list in the order the API returned it — the server owns display order. */
export function AssessmentList({
  items,
  canEdit,
}: {
  items: AssessmentListItem[]
  canEdit: boolean
}) {
  if (items.length === 0) return <AssessmentEmptyState />
  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => (
        <AssessmentCard key={item.organizationSurveyId} item={item} canEdit={canEdit} />
      ))}
    </div>
  )
}
